import SvgSmallLogo from '../../../assets/svg/SmallLogo';
import './Loader.css';

function Loader() {
    return (
        <div className="loader-logo">
            <SvgSmallLogo/>
        </div>
    );
}

export default Loader;